export const forceArray = <T>(v: T | T[]) => {
  if (Array.isArray(v)) return v;
  return [v];
}